import { tokens, Typography } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import type { ContractReviewMessage } from "../../../amplify/backend/function/OfferExpCheckout/ts/public/types";

type ContractReviewIssuesListProps = {
  messages: ContractReviewMessage[];
};

const ContractReviewIssuesList = ({
  messages,
}: ContractReviewIssuesListProps) => (
  <OrderedList>
    {messages.map((msg, index) => (
      <li key={`${msg.category}-${index}`}>
        <IssueLine as="span" color={tokens.TINTS_OFF_WHITE_20}>
          <UnderlinedTitle>{msg.message}</UnderlinedTitle>
          {msg.suggestion ? (
            <>
              {": "}
              {msg.suggestion}
            </>
          ) : null}
        </IssueLine>
      </li>
    ))}
  </OrderedList>
);

const OrderedList = styled.ol`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const IssueLine = styled(Typography)`
  display: block;
`;

const UnderlinedTitle = styled.span`
  text-decoration: underline;
`;

export { ContractReviewIssuesList };
export type { ContractReviewIssuesListProps };
